/**
 * TODO: look into middleware to map query params to the values we need.
 * For example ?Name=xx_GHRabatt2_xx could be mapped to ?discount=2, so we can use useRouter without having to transform the query params.
 * For more infos look here:
 * - https://teams.microsoft.com/l/message/19:039100abfeb54ecca3a08e3cdcb48ced@thread.tacv2/1666258629529?tenantId=8794e153-c3bd-4479-8bea-61aeaf167d5a&groupId=63034894-68f5-47c3-8d67-7238613ff7c8&parentMessageId=1664531155212&teamName=EMP_DEVELOPER&channelName=FE%20Support%20(Codeaholics%20Anonymous)&createdTime=1666258629529&allowXTenantAccess=false
 * - https://nextjs.org/docs/advanced-features/middleware
 */

/**
 * This helper function checks if the URL query param has a correct value.
 * The Url looks like this: tenant/p/AKLBB/?Name=xx_GHRabatt2_xx
 * If this is the case it returns a `number`, which represents the discount value in percentage,
 * otherwise it returns `null`.
 *
 * @param searchParams - URL search params
 *
 * @returns number | null
 */
export function getVoucherPriceDiscountPercent(searchParams: URLSearchParams): number | null {
  const discountURLIdentifier = 'GHRabatt';
  let discountQueryValue: string | null = null;

  // get query value for Name ?Name=xx_GHRabatt2_xx should be xx_GHRabatt2_xx
  discountQueryValue = searchParams.get('Name');

  if (discountQueryValue === null || typeof discountQueryValue !== 'string') {
    return null;
  }

  // example: discountQueryValue = 17777_GHRabatt2_UE
  if (discountQueryValue.indexOf(discountURLIdentifier) > 0) {
    // get suffix -> "2_UE"
    const suffix = discountQueryValue.split(discountURLIdentifier)[1];
    // get discount ->"2"
    const discountString = suffix.split('_')[0];
    // transform discount to number -> 2
    const discountInt = parseInt(discountString, 10);

    if (Number.isNaN(discountInt) === false) {
      return discountInt;
    }
  }

  return null;
}
